export default "__VITE_ASSET__5b4a6def__"